import * as z from 'zod';

export const infrastructureQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type InfrastructureQueryLinkerSchema = z.infer<typeof infrastructureQueryLinkerSchema>;
